import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SearchPage from './pages/SearchPage';
import CustomerDetail from './pages/CustomerDetail';
import UploadExcel from './pages/UploadExcel';
import SearchInsuranceCustomer from './pages/SearchInsuranceCustomer';
import InsuranceCustomerDetail from './pages/InsuranceCustomerDetail';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3500,
              style: {
                borderRadius: '10px',
                fontSize: '13px',
                fontFamily: 'Inter, system-ui, sans-serif',
              },
              success: {
                iconTheme: { primary: '#0ea5e9', secondary: '#fff' },
              },
            }}
          />
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout><Navigate to="/dashboard" replace /></Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Layout><Dashboard /></Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/search"
              element={
                <ProtectedRoute>
                  <Layout><SearchPage /></Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/customer/:id"
              element={
                <ProtectedRoute>
                  <Layout><CustomerDetail /></Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/upload-excel"
              element={
                <ProtectedRoute>
                  <Layout><UploadExcel /></Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/search-insurance"
              element={
                <ProtectedRoute>
                  <Layout><SearchInsuranceCustomer /></Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/insurance-customer/:id"
              element={
                <ProtectedRoute>
                  <Layout><InsuranceCustomerDetail /></Layout>
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;